import styled, { css } from "styled-components";
import { HexColor } from "../../../types/styles";

const iconStyles = css`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const StyledAlert = styled.div<{
  color: HexColor;
  small: boolean;
}>`
  background-color: ${({ color }) => color};
  border-radius: 5px;
  display: flex;
  gap: 8px;
  line-height: normal;
  padding: ${({ small }) => (small ? "4px 8px" : "12px")};
  position: relative;
`;

export const StyledIcon = styled.div<{ small: boolean }>`
  ${iconStyles}
  height: ${({ small }) => (small ? "20px" : "24px")};
  width: ${({ small }) => (small ? "20px" : "24px")};
`;

export const StyledCloseIcon = styled.div<{ small: boolean }>`
  ${iconStyles}
  height: ${({ small }) => (small ? "20px" : "24px")};
  width: ${({ small }) => (small ? "20px" : "24px")};
  padding: 4px 2px;
  cursor: pointer;
  margin-left: auto;
`;

export const StyledContent = styled.div<{ small: boolean; large: boolean }>`
  padding: ${({ small, large }) => {
    if (small) {
      return `2px 0 2px`;
    }
    if (large) {
      return `1px 0 1px`;
    }
    return `4px 0 4px`;
  }};
`;

export const StyledText = styled.div<{
  bold: boolean;
  closable: boolean;
  color: HexColor;
  gutterBottom?: boolean;
  isTitle?: boolean;
  large?: boolean;
}>`
  font-size: ${({ large, isTitle }) => {
    if (large && isTitle) {
      return "18px";
    }
    if (large) {
      return "16px";
    }
    return "13px";
  }};
  color: ${({ color }) => color};

  ${({ gutterBottom, large }) => {
    if (gutterBottom && large) {
      return `margin-bottom: 12px;`;
    }
    if (gutterBottom) {
      return `margin-bottom: 4px;`;
    }
    return;
  }};

  ${({ bold }) =>
    bold &&
    `
    font-weight: 700;
  `}

  ${({ closable }) =>
    closable &&
    `
    padding-right: 8px;
  `}
`;

export const StyledChildrenWrapper = styled.div<{
  color: HexColor;
}>`
  line-height: normal;
  font-size: 13px;
  &,
  * {
    color: ${({ color }) => color};
  }
`;
